let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9yUm3")).then(() => parcelRequire('3Gv94'));